export const ENV_PROD = 'production';
export const ENV_DEV = 'development';
export const ENV_LOCAL = 'local';
export const ENV_TEST = 'test';



// WEBPACK FOOTER //
// ./src/constants/env.js